import React, { ReactNode, useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "../components/layout";
import NoLayout from "../components/layout/noLayout";
import { useAppSelector } from "../store";
import ArbitratorsLayout from "../components/arbitrators_layout";
import { _routes, sidebar_routes } from ".";
import useGetAllData from "../hooks/useGetAllData";
import useUrlQueryParams from "../hooks/useUrlQeryParams";
import NotFoundPage from "../pages/not_found";
import i18next from "i18next";
import LoaderComponent from "../components/loader";
import { ICategories } from "../models/categories";
import { IInformation } from "../models/information";

const RoutesMiddleware = () => {
  const auth = useAppSelector((state) => state?.user);
  const location = useLocation();

  const getSubstringAfterColon = (str: string): string => {
    const index = str.indexOf(":");
    return index === -1 ? "" : str.substring(index + 1);
  };

  const category_id = getSubstringAfterColon(location?.pathname);

  const { urlValue } = useUrlQueryParams({
    currentPage: 1,
    perPage: 10,
  });

  const { data, isLoading: categoriesLoading } = useGetAllData<ICategories[]>({
    queryKey: ["categories", category_id],
    url: "categories",
    options: {
      enabled: Boolean(category_id),
    },
  });

  const {
    data: information,
    refetch: refetchInformation,
    isLoading: informationLoading,
  } = useGetAllData<IInformation[]>({
    queryKey: [
      "information",
      urlValue.perPage,
      urlValue.currentPage,
      category_id,
      localStorage.getItem("i18lang"),
    ],
    url: "information",
    urlParams: {
      perPage: urlValue.perPage,
      page: urlValue.currentPage,
      "category.id": category_id,
    },
    options: { enabled: !!category_id },
  });

  console.log("information", information);

  useEffect(() => {
    const handleLanguageChange = () => {
      refetchInformation();
    };
    i18next.on("languageChanged", handleLanguageChange);
    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, []);

  const createComponent = (
    Component: any,
    useLayout: boolean = false
  ): ReactNode => {
    const component = <Component />;
    return useLayout ? (
      <Layout>{component}</Layout>
    ) : (
      <NoLayout>{component}</NoLayout>
    );
  };

  if (informationLoading || categoriesLoading) {
    return <LoaderComponent />;
  }

  // Dinamik routelarni yaratish funksiyasi
  const renderDynamicRoutes = () =>
    data?.map((item: any) => {
      if (item?.children?.length) {
        return item?.children?.map((element: any) => {
          if (element?.children?.length) {
            return element?.children?.map((subElement: any) => (
              <Route
                key={subElement?.path}
                path={`${subElement?.path}/:${subElement?.id}`}
                element={
                  <ArbitratorsLayout>
                    <div
                      className="editor-content"
                      contentEditable={false}
                      dangerouslySetInnerHTML={{
                        __html: information
                          ?.map((item: any) => item?.description || "")
                          .join(""),
                      }}
                    />
                  </ArbitratorsLayout>
                }
              />
            ));
          }
          return (
            <Route
              key={element?.path}
              path={`${element?.path}/:${element?.id}`}
              element={
                <ArbitratorsLayout>
                  <div
                    contentEditable="false"
                    dangerouslySetInnerHTML={{
                      __html: `${information?.map(
                        (item: any) => item?.description
                      )}`,
                    }}
                  />
                </ArbitratorsLayout>
              }
            />
          );
        });
      }
      return (
        <Route
          key={item?.path}
          path={`${item?.path}/:${item?.id}`}
          element={
            <ArbitratorsLayout>
              <div
                contentEditable="false"
                dangerouslySetInnerHTML={{
                  __html: `${information?.map(
                    (item: any) => item?.description
                  )}`,
                }}
              />
            </ArbitratorsLayout>
          }
        />
      );
    });

  if (auth?.isLoggedIn) {
    // Ro‘yxatdan o‘tgan bo‘lsa barcha routelar
    return (
      <Routes>
        {/* Sidebar routelari (Layout bilan) */}
        {sidebar_routes?.map((item) =>
          item?.submenu?.length && item?.config?.structure === "layout" ? (
            item?.submenu?.map((element) => (
              <Route
                key={element?.path}
                path={element?.path}
                element={createComponent(element?.component, true)} // Layout bilan
              />
            ))
          ) : (
            <Route
              key={item?.path}
              path={item?.path}
              element={createComponent(item?.component, true)} // Layout bilan
            />
          )
        )}

        {/* _routes (NoLayout yoki ArbitratorsLayout bilan) */}
        {_routes?.map((item) =>
          item?.config?.structure === "extraLayout" ? (
            item?.submenu?.length ? (
              item?.submenu?.map((element) => (
                <Route
                  key={element?.path}
                  path={element?.path}
                  element={
                    <ArbitratorsLayout>
                      {createComponent(element?.component)}
                    </ArbitratorsLayout>
                  }
                />
              ))
            ) : (
              <Route
                key={item?.path}
                path={item?.path}
                element={
                  <ArbitratorsLayout>
                    {createComponent(item?.component)}
                  </ArbitratorsLayout>
                }
              />
            )
          ) : (
            <Route
              key={item?.path}
              path={item?.path}
              element={createComponent(item?.component, false)} // NoLayout bilan
            />
          )
        )}

        {/* Dinamik routelar */}
        {renderDynamicRoutes()}

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  }

  // Ro‘yxatdan o‘tmagan bo‘lsa faqat NoLayout routelari
  return (
    <NoLayout>
      <Routes>
        {_routes?.map((item) =>
          item?.config?.structure === "extraLayout" ? (
            item?.submenu?.length ? (
              item?.submenu?.map((element) => (
                <Route
                  key={element?.path}
                  path={element?.path}
                  element={
                    <ArbitratorsLayout>
                      {createComponent(element?.component)}
                    </ArbitratorsLayout>
                  }
                />
              ))
            ) : (
              <Route
                key={item?.path}
                path={item?.path}
                element={
                  <ArbitratorsLayout>
                    {createComponent(item?.component)}
                  </ArbitratorsLayout>
                }
              />
            )
          ) : (
            <Route
              key={item?.path}
              path={item?.path}
              element={createComponent(item?.component, false)} // NoLayout bilan
            />
          )
        )}

        {/* Dinamik routelar */}
        {renderDynamicRoutes()}

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </NoLayout>
  );
};

export default RoutesMiddleware;
